import { Component, Input, OnInit, WritableSignal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteResultsHeaderComponent } from './components/route-results-header/route-results-header.component';
import { RouteFormResult } from '../route-form/models/routeRequestResults.model';
import { RouteResultsOptionsComponent } from './components/route-results-options/route-results-options.component';
import { RouteResultsService } from './services/route-results.service';
import { allOption, bikeOption, busOption, walkOption } from '../route-form/components/route-form-options-panels/components/route-form-more-options/constants';

@Component({
  selector: 'app-route-results',
  standalone: true,
  imports: [CommonModule, RouteResultsHeaderComponent, RouteResultsOptionsComponent],
  templateUrl: './route-results.component.html',
  styleUrls: ['./route-results.component.scss']
})
export class RouteResultsComponent implements OnInit {

  @Input({required: true}) routeFormResults!: WritableSignal<RouteFormResult|null>;

  public routeResultOptionSelected = inject(RouteResultsService).resultOptionSelected;

  ngOnInit() {
    if(this.routeFormResults()![this.routeResultOptionSelected().id].plan.minDuration === -1){
      if(this.routeFormResults()!.all.plan.minDuration !== -1){
        this.routeResultOptionSelected.set(allOption);
      } else if (this.routeFormResults()!.bus.plan.minDuration !== -1){
        this.routeResultOptionSelected.set(busOption);
      } else if (this.routeFormResults()!.walk.plan.minDuration !== -1){
        this.routeResultOptionSelected.set(walkOption);
      } else if (this.routeFormResults()!.bicycle.plan.minDuration !== -1){
        this.routeResultOptionSelected.set(bikeOption);
      }
    }
  }


}
